import type { InputDropdownOption } from '@interxfi/design-system/components/input/shared/dropdown/input-dropdown';
import type { I18nNamespaces, TFunction } from '@interxfi/translation';
import { sortByKey } from '@interxfi/utilities/sort';

export function enumToOptions<TEnum extends Record<string, TValue>, TValue extends string = string>(
  t: TFunction,
  enumObject: TEnum,
  i18nBaseKey: `${I18nNamespaces}:${string}`,
  sortByLabel = true,
) {
  const options = Object.entries(enumObject).reduce<InputDropdownOption<TValue>[]>((accum, [k, v]) => {
    accum.push({
      label: t(`${i18nBaseKey}.${v}`, { defaultValue: enumObject[v] || k }),
      value: v,
    });

    return accum;
  }, []);

  return sortByLabel ? sortByKey(options, (x) => x.label) : options;
}
